import { ofType } from 'redux-observable';
import { of, Subject } from 'rxjs';
import { mergeMap, take, takeUntil } from 'rxjs/operators';

import { noop } from 'ui-components/default-props/noop';

import { InsuranceTermsService } from './insurance-terms-service';
import { USER_SETTING_SAVE_REQUEST_SUCCESS } from '../store/user/user.actions';

export const launchShipsuranceTermsModalWaitToProceed = (action$, nextAction, insuranceProviderId) => {
  const cancelSubject = new Subject();
  const onDeclineTerms = () => cancelSubject.next(true);
  InsuranceTermsService.launchInsuranceTermsModal(noop, onDeclineTerms, insuranceProviderId);
  return action$.pipe(
    takeUntil(cancelSubject),
    ofType(USER_SETTING_SAVE_REQUEST_SUCCESS),
    take(1),
    mergeMap(() => {
      return of(nextAction);
    }),
  );
};
